import { useCallback } from 'react';
import { useSTypeGrpId } from '../../../../../../Components/Sections/online/sections/details/positionDetails/sTypeGroupTable/context/sTypeGrpId';

export const useFilterByBySTypeGrpId = () => {
  const sTypeGrpId = useSTypeGrpId();
  const fn = useCallback((line) => `${line['S_TYPE_GRP.ID']}` === `${sTypeGrpId}`, [sTypeGrpId]);
  return fn;
};
